<script>
const SkeletonClients = Object.freeze([
  { lineWidth: 260, subtitleLineWidth: 150, locationLineWidths: [] },
  {
    lineWidth: 220,
    subtitleLineWidth: 180,
    locationLineWidths: [140, 160],
  },
  { lineWidth: 240, subtitleLineWidth: 160, locationLineWidths: [] },
  { lineWidth: 190, subtitleLineWidth: 130, locationLineWidths: [] },
])

export default {
  name: 'CandidatePreferenceListSkeleton',
  data() {
    return {
      skeletonClients: SkeletonClients,
    }
  },
}
</script>

<template>
  <div class="preference-modal__skeleton" aria-busy="true" aria-live="polite">
    <div
      v-for="(client, clientIndex) in skeletonClients"
      :key="`preference-client-skeleton-${clientIndex}`"
      class="preference-modal__skeleton-group"
    >
      <div class="preference-modal__skeleton-row">
        <v-skeleton-loader
          loading
          type="image"
          class="preference-modal__checkbox-skeleton"
          aria-hidden="true"
          aria-live="off"
          role="presentation"
        />
        <div class="preference-modal__client-text-skeleton">
          <v-skeleton-loader
            loading
            type="image"
            class="preference-modal__client-line-skeleton"
            :style="{ width: `${client.lineWidth}px` }"
            aria-hidden="true"
            aria-live="off"
            role="presentation"
          />
          <v-skeleton-loader
            loading
            type="image"
            class="preference-modal__subtitle-line-skeleton"
            :style="{ width: `${client.subtitleLineWidth}px` }"
            aria-hidden="true"
            aria-live="off"
            role="presentation"
          />
        </div>
        <span class="preference-modal__disclosure-skeleton" />
      </div>

      <div
        v-if="client.locationLineWidths.length"
        class="preference-modal__skeleton-locations"
      >
        <div
          v-for="(lineWidth, locationIndex) in client.locationLineWidths"
          :key="`preference-location-skeleton-${locationIndex}`"
          class="preference-modal__skeleton-location-row"
        >
          <v-skeleton-loader
            loading
            type="image"
            class="preference-modal__checkbox-skeleton"
            aria-hidden="true"
            aria-live="off"
            role="presentation"
          />
          <v-skeleton-loader
            loading
            type="image"
            class="preference-modal__location-line-skeleton"
            :style="{ width: `${lineWidth}px` }"
            aria-hidden="true"
            aria-live="off"
            role="presentation"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@styles';

.preference-modal__skeleton {
  padding: 0;
}

.preference-modal__skeleton-row,
.preference-modal__skeleton-location-row {
  display: flex;
  align-items: center;
  background-color: $neutrals-black-and-white-white;
  border-bottom: 1px solid $neutrals-grey-200;
}

.preference-modal__skeleton-row {
  min-height: 68px;
  padding: $spacing-xs + $spacing-4xs $spacing-lg;
}

.preference-modal__checkbox-skeleton {
  flex: 0 0 22px;
  width: 22px;
  height: 22px;
  margin-right: $spacing-sm + $spacing-4xs;
}

.preference-modal__disclosure-skeleton {
  display: block;
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  margin-left: $spacing-sm;
}

.preference-modal__client-text-skeleton {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  gap: $spacing-3xs;
}

.preference-modal__client-line-skeleton,
.preference-modal__subtitle-line-skeleton,
.preference-modal__location-line-skeleton {
  flex-shrink: 1;
  max-width: 100%;
}

.preference-modal__client-line-skeleton {
  height: 14px;
}

.preference-modal__subtitle-line-skeleton {
  height: 12px;
}

.preference-modal__skeleton-locations {
  display: flex;
  flex-direction: column;
}

.preference-modal__skeleton-location-row {
  min-height: 50px;
  padding: $spacing-xs + $spacing-4xs $spacing-lg $spacing-xs + $spacing-4xs
    66px;
}

.preference-modal__location-line-skeleton {
  height: 14px;
}

::v-deep.preference-modal__checkbox-skeleton,
::v-deep.preference-modal__client-line-skeleton,
::v-deep.preference-modal__subtitle-line-skeleton,
::v-deep.preference-modal__location-line-skeleton {
  .v-skeleton-loader__image {
    width: 100%;
    height: 100%;
    background: $neutrals-grey-200;
    border-radius: 4px;
  }
}
</style>
